import styled, { css } from "styled-components";
import defaultTheme from "../../../defaultTheme";
const StyledRelative = styled.div.withConfig({
  displayName: "StyledRelative",
  componentId: "sc-1evkvci-0"
})(["position:relative;", ";"], ({
  inner,
  theme
}) => inner && css(["width:calc(100% + ", "px);display:flex;align-items:center;"], parseInt(theme.orbit.spaceSmall, 10) + 4));
StyledRelative.defaultProps = {
  theme: defaultTheme
};
export default StyledRelative;